import { render } from "./MgoSection.vue?vue&type=template&id=fb662e4c&scoped=true"
import script from "./MgoSection.vue?vue&type=script&lang=js"
export * from "./MgoSection.vue?vue&type=script&lang=js"

import "./MgoSection.vue?vue&type=style&index=0&id=fb662e4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb662e4c"]])

export default __exports__